import { render } from "./Approaches.vue?vue&type=template&id=4bc58f56&ts=true"
import script from "./Approaches.vue?vue&type=script&lang=ts"
export * from "./Approaches.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__